import type { FC } from 'react'

import Checkbox from '@/components/Checkbox'

export interface Filter {
  onlyShowNoOwner: boolean
}

export const DEFAULT_FILTER: Filter = {
  onlyShowNoOwner: false,
}

interface Props {
  filter: Filter
  onChangeFilter: (filter: Filter) => void
}

const NoOwnerFilter: FC<Props> = ({ filter, onChangeFilter }) => (
  <Checkbox
    label="Just show applicants with no owner"
    checked={filter.onlyShowNoOwner}
    onChange={e =>
      onChangeFilter({
        ...filter,
        onlyShowNoOwner: e.target.checked,
      })
    }
  />
)

export default NoOwnerFilter
